var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteCalloutInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UX-429-Invite-User-Via-Sms-Dialpad-VidyoConnect-Desktop-v7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A01",
    transform: "translate(-453.000000, -418.000000)",
    fill: "#B4C3D0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invite",
    transform: "translate(420.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(33.571429, 140.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2785544,9.52329128 C18.7935932,9.52731236 18.3053053,9.35065981 18.1254599,8.46386818 C18.0904859,8.29460056 18.0745528,8.10679218 18.0744487,7.90362111 C17.812293,4.30346645 16.7318694,3.73243502 12.1986985,3.70418394 L11.4274578,3.6980426 L10.6736652,3.70409187 C6.12520689,3.73243454 5.0448255,4.30761158 4.78279848,7.8994917 C4.78279848,8.10652831 4.76642236,8.29508373 4.73244293,8.4623247 C4.55170042,9.35014576 4.07692971,9.52156854 2.5791477,9.52329157 L2.39254001,9.52282674 L2.20126149,9.52329197 C1.06507905,9.52568695 0.715019207,9.48176877 0.364743023,9.1152108 C0.105770431,8.84537664 0,8.4354468 0,7.8994917 C0,1.920674 3.75757807,0 11.4285714,0 C19.0995648,0 22.8571429,1.920674 22.8571429,7.8994917 C22.8571429,8.43498649 22.7515567,8.84482319 22.4936027,9.11441777 C22.1404631,9.48397174 21.77487,9.52955122 20.6557226,9.52329161 L20.4657517,9.52282954 L20.2785544,9.52329128 Z",
    id: "Fill-1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52380952,7.40258065 L9.52380952,7.95698925 L13.3350265,7.95698925 L13.3350265,7.40258065 C13.3350265,6.71266129 14.0448479,6.66954133 14.4174762,6.66684633 L15.1453968,6.66666667 C15.4903704,6.66666667 16.2979894,6.66666667 16.2979894,7.40258065 L16.2979894,8.43913978 C16.7478211,8.94622353 17.6225998,10.0640062 18.4933109,11.2392447 L18.864973,11.744823 C19.9102222,13.1781218 20.8591053,14.5796025 20.9434921,14.9587097 L20.9540741,15.0537634 L20.9540741,18.9247312 C20.9540741,19.5178495 20.4791534,20 19.895873,20 L2.96296296,20 C2.37968254,20 1.9047619,19.5178495 1.9047619,18.9247312 L1.91492063,14.9587097 C2.06941799,14.2662366 5.41333333,9.72129032 6.56084656,8.43827957 L6.56084656,7.40258065 C6.56084656,6.71266129 7.27066799,6.66954133 7.64364511,6.66684633 L8.37164021,6.66666667 C8.71619048,6.66666667 9.52380952,6.66666667 9.52380952,7.40258065 Z M11.4285714,10.4761905 C9.85316017,10.4761905 8.57142857,11.7579221 8.57142857,13.3333333 C8.57142857,14.9083983 9.85316017,16.1904762 11.4285714,16.1904762 C13.0039827,16.1904762 14.2857143,14.9083983 14.2857143,13.3333333 C14.2857143,11.7579221 13.0039827,10.4761905 11.4285714,10.4761905 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteCalloutInactive);
export default __webpack_public_path__ + "static/media/invite_callout_inactive.ddc806f0609673d279094ef74bd99d8f.svg";
export { ForwardRef as ReactComponent };